<div class="toolbar-user-menu-popover">
  <ul
    class="toolbar-user-menu-popover__list"
    data-id="toolbar-user-menu-popover"
  >
    <li
      routerLink="/account"
      data-id="toolbar-user-menu-option-account"
      tabindex="0"
    >
      <i class="pi pi-user"></i>
      <span>Account</span>
    </li>
    <li
      tabindex="1"
      (click)="logout()"
      (keydown)="logout()"
      data-id="toolbar-user-menu-option-logout"
    >
      <i class="pi pi-sign-out"></i>
      <span>Log out</span>
    </li>
  </ul>
</div>
@if (isLoaderShown) {
  <cw-loader-inline
    [global]="true"
    [bindHostClass]="false"
  />
}
